// @ts-ignore
import Splide from '@splidejs/splide';

export class Slider {
    sliders: NodeListOf<HTMLElement>;

    constructor() {
        this.sliders = document.querySelectorAll('[data-slider]');
        this.init();
    }

    init() {
        this.sliders.forEach((slider) => {
            let options = {...{
                    type: 'loop',
                    perPage: 1,
                    gap: 10,
                    classes: {
                        arrows: 'splide__arrows c-slider__arrows',
                        arrow: 'splide__arrow c-slider__arrow',
                        prev: 'splide__arrow--prev c-slider__arrow--prev',
                        next: 'splide__arrow--next c-slider__arrow--next',
                    },
                    pagination: false,
                    mediaQuery: 'min',
                    breakpoints: {
                        768: {
                            gap: 20,
                        }
                    },
                }, ...JSON.parse(slider.dataset.slider)}
            const splide = new Splide(slider, options);
            splide.mount();
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    new Slider();
});
